import {IDynaCMSClientConfig} from "../packages/dyna-cms-client/DynaCMSClient";
import {serviceAddress} from "./serviceAddress";

export const dynaCMSConfig: IDynaCMSClientConfig = {
  serviceAddress: serviceAddress("dyna-cms"),
  cacheLimit: 5000000,
  cacheContentExpiresInMin: 5,
};
